<template>
  <b-form class="py-4">
    <b-form-row>
      <b-col>
        <b-form-input
          v-model="corporate.full_name"
          id="input-full-name"
          placeholder="Full Name"
          type="text"
        />
      </b-col>
      <b-col>
        <b-form-input
          v-model="corporate.phone_number"
          id="input-phone-number"
          placeholder="Phone Number"
          type="text"
          @keypress="numberOnly($event)"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col>
        <b-form-input
          v-model="corporate.email"
          id="input-email"
          placeholder="Email"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col>
        <b-form-input
          v-model="corporate.position"
          id="input-position"
          placeholder="Position"
          type="text"
        />
      </b-col>
      <b-col>
        <b-form-input
          v-model="corporate.division"
          id="input-division"
          placeholder="Division"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col>
        <b-form-input
          v-model="corporate.company"
          id="input-company"
          placeholder="Company"
          type="text"
        />
      </b-col>
      <b-col>
        <InputSelect
          @passToParent="childData"
          :val="corporate.type"
          id="type"
          text="Type"
          :options="type_options"
          hide_label=true
        />
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col>
        <b-form-input
          v-model="corporate.company_url"
          id="input-company-url"
          placeholder="Company URL"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col>
        <InputTextarea
          @passToParent="childData"
          :val="corporate.description"
          id="description"
          text="Tell us how you would partner with us.."
          hide_label=true
        />
      </b-col>
    </b-form-row>

    <b-form-row class="mt-4 justify-content-center">
        <b-col cols="6">
          <b-button variant="primary" block @click="addCorporateRelation">Submit</b-button>
        </b-col>
      </b-form-row>
  </b-form>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component
import InputSelect from '@/templates/InputSelect'
import InputTextarea from '@/templates/InputTextarea'

// api call
import CorporateAPI from '@/api/CorporateAPI'

export default {
  name: 'FormCorporate',
  components: {
    InputSelect,
    InputTextarea
  },
  data () {
    return {
      corporate: {
        full_name: '',
        phone_number: '',
        email: '',
        position: '',
        division: '',
        company: '',
        company_url: '',
        type: null,
        description: ''
      },

      type_options: [
        { value: null, text: 'Select Type', disabled: true },

        { value: 'pt', text: 'PT' },
        { value: 'swasta', text: 'Swasta' }
      ],

      errors: []
    }
  },
  methods: {
    // PREREQUISITES
    childData (id, value) {
      // catch value from custom form template
      this.corporate[id] = value
    },

    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    routeToHome: function () {
      this.$router.push({ name: 'Home' })
    },
    numberOnly: function (evt) {
      evt = (evt) || window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // END PREREQUISITES

    // HTTP REQUEST
    addCorporateRelation: async function () {
      this.errors = []

      if (!this.corporate.full_name) { this.errors.push('Full Name Required.') }
      if (!this.corporate.phone_number) { this.errors.push('Phone Number Required.') }
      if (!this.corporate.email) {
        this.errors.push('Email required.')
      } else if (!this.validEmail(this.corporate.email)) {
        this.errors.push('Invalid email format.')
      }
      if (!this.corporate.description) { this.errors.push('Please tell us the reason to partner with us..') }

      if (this.errors.length) {
        swal({
          title: 'Please check your input.',
          text: this.errors[0],
          icon: 'error',
          button: {
            text: 'Ok'
          },

          closeOnClickOutside: false,
          closeOnEsc: false
        })
      } else {
        const response = await CorporateAPI.addCorporateRelation(this.corporate)
        console.log(response)

        if (response.data.success) {
          swal({
            title: 'Success!',
            text: 'We\'ve receive your inquiry, let us contact you further.',
            icon: 'success',
            button: {
              text: 'Ok'
            },
            onClose: this.routeToHome()
          })
        } else {
          swal({
            title: 'Failed',
            text: 'Please check your input',
            icon: 'error',
            button: {
              text: 'Ok'
            },

            closeOnClickOutside: false,
            closeOnEsc: false
          })
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/templates/FormCorporate/FormCorporate.vue